import {
  MOSTRAR_MONITOREO_EVALUACIONES,
  MOSTRAR_MONITOREO_EVALUACION,
  LOADING_MONITOREO_EVALUACION,
  MONITOREO_EVALUACION_FAILED,
  CREAR_MONITOREO_EVALUACION,
  MONITOREO_EVALUACION_SUCCEEDED,
  ACTUALIZAR_MONITOREO_EVALUACION,
} from "../types";

import { api_basev2 } from "../../config";
import { getData } from "../../utils/api-client";

const obtenerEvaluacionRespuesta = (resultado, payload) => {
  const data = resultado.data?.data || resultado.data;

  if (data && typeof data === "object" && !Array.isArray(data)) {
    return { ...payload, ...data };
  }

  return payload;
};

export const getMonitereoEvaluacionCriteriosById = (monitoreoId) => async (dispatch) => {
    let urlv2 = api_basev2 +
      `MonitoreoEvaluaciones/ObtenerMonitoreoEvaluadoById?monitoreoId=${monitoreoId}`;

    dispatch({ type: LOADING_MONITOREO_EVALUACION });
    await getData
      .get(urlv2)
      .then((resultado) => {
        dispatch({ type: MOSTRAR_MONITOREO_EVALUACION, payload: resultado.data.data });
      })
      .catch((error) => {
        if (error) {
          dispatch({ type: MONITOREO_EVALUACION_FAILED });
        }
      });
  };

export const getMonitereoEvaluadas = () => async (dispatch) => {
  let urlv2 = api_basev2 + `MonitoreoEvaluaciones/ObtenerMonitoreosEvaluados`;

  dispatch({ type: LOADING_MONITOREO_EVALUACION });
  await getData
    .get(urlv2)
    .then((resultado) => {
      dispatch({
        type: MOSTRAR_MONITOREO_EVALUACIONES,
        payload: resultado.data.data,
      });
    })
    .catch((error) => {
      if (error) {
        dispatch({ type: MONITOREO_EVALUACION_FAILED });
      }
    });
};
export const guardarMonitoreoEvaluacion = (evaluaciones) => async dispatch => {
  const urlv2 = api_basev2 + `MonitoreoEvaluaciones/SaveMonitoreo`;

  dispatch({ type: LOADING_MONITOREO_EVALUACION });

  try {
    const evaluacionesGuardadas = [];

    for (const ev of evaluaciones) {
      const payload = {
        monitoreoId: ev.monitoreoId,
        criterioId: ev.criterioId,
        resultado: Math.round(ev.resultado)
      };

      const resultado = await getData.post(urlv2, payload);
      evaluacionesGuardadas.push(obtenerEvaluacionRespuesta(resultado, payload));
    }

    dispatch({ type: CREAR_MONITOREO_EVALUACION, payload: evaluacionesGuardadas });
    dispatch({ type: MONITOREO_EVALUACION_SUCCEEDED });
    return evaluacionesGuardadas;
  } catch (error) {
    dispatch({ type: MONITOREO_EVALUACION_FAILED });
    throw error;
  }
};

export const actualizarMonitoreoEvaluacion = (evaluaciones) => async (dispatch) => {
  const urlActualizar =
    api_basev2 + `MonitoreoEvaluaciones/UpdateMonitoreoEvaluacion`;
  const urlGuardar = api_basev2 + `MonitoreoEvaluaciones/SaveMonitoreo`;

  dispatch({ type: LOADING_MONITOREO_EVALUACION });

  try {
    const evaluacionesActualizadas = [];

    for (const ev of evaluaciones) {
      const esActualizacion = Boolean(ev.monitoreoEvaluacionId);
      const payload = {
        monitoreoId: ev.monitoreoId,
        criterioId: ev.criterioId,
        resultado: Math.round(ev.resultado)
      };

      if (esActualizacion) {
        payload.monitoreoEvaluacionId = ev.monitoreoEvaluacionId;
      }
    
      const resultado = await getData.post(
        esActualizacion ? urlActualizar : urlGuardar,
        payload
      );
      evaluacionesActualizadas.push(obtenerEvaluacionRespuesta(resultado, payload));
    }

    dispatch({ type: ACTUALIZAR_MONITOREO_EVALUACION, payload: evaluacionesActualizadas });
    dispatch({ type: MONITOREO_EVALUACION_SUCCEEDED });
    return evaluacionesActualizadas;
  } catch (error) {
    if (error) {
      dispatch({ type: MONITOREO_EVALUACION_FAILED });
    }
    throw error;
  }
  
};
